import { v4 as uuid } from 'uuid';

import { setSendAnswerFailed, setSendAnswerPending, setSendAnswerSuccess } from './actions';
import { trackBubbleInputSend } from './tracking';
import { IWsAnswerEvent } from './types';
import { currentOpenChatIDSelector } from '../../selectors';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { ISessionSucceedState } from '../../types/session';
import { timeoutPromise } from '../../utils/timeoutPromise';
import { EInternetStatus } from '../internetStatus';
import { setSocketFailed } from '../socket';

type TSendWsAnswerParams = {
  messageId: string;
  payload: string;
  input?: string;
  analyticsBubbleType?: string;
};

/**
 * Отправка действия по WS
 */
export const sendWsAnswer =
  ({ messageId, payload, input, analyticsBubbleType }: TSendWsAnswerParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger }) => {
    const {
      session: { status, token },
      socket: { eventChannel, clientEvents, status: socketStatus },
      internetStatus,
    } = getState();

    const chatId = currentOpenChatIDSelector(getState()) || '';

    dispatch(setSendAnswerPending());

    const isSessionExpired = status !== ERequestApiStatus.Succeed;
    const isSocketIsClose = eventChannel.isChannelClosed() || socketStatus === ERequestApiStatus.Failed;
    const isOffline = internetStatus === EInternetStatus.Offline;

    const uid = uuid();

    if (isSocketIsClose) {
      dispatch(setSocketFailed());
    }

    if (isSessionExpired || isSocketIsClose || isOffline) {
      clientEvents.set(uid, { type: EWsClientEventType.Answer, status: ERequestApiStatus.Failed });
      dispatch(setSendAnswerFailed());

      return;
    }

    const wsAnswer: IWsAnswerEvent = {
      type: EWsClientEventType.Answer,
      uid,
      message: {
        messageId,
        payload,
        ...(input && { input }),
      },
      userId: (token as ISessionSucceedState['token']).userId,
      sessionToken: (token as ISessionSucceedState['token']).sessionToken,
    };

    clientEvents.set(uid, {
      status: ERequestApiStatus.Pending,
      type: EWsClientEventType.Answer,
    });

    try {
      await timeoutPromise(eventChannel.sendAnswer(wsAnswer), 10000);
      dispatch(setSendAnswerSuccess());

      if (input && analyticsBubbleType) {
        trackBubbleInputSend(chatId, analyticsBubbleType);
      }
    } catch (err) {
      logger.warning(err, {
        domain: 'frontend-chats.sendWsAnswer.ts',
        message: 'Не удалось отправить действие по ws',
      });

      clientEvents.set(uid, { type: EWsClientEventType.Answer, status: ERequestApiStatus.Failed });
      dispatch(setSendAnswerFailed());
    }
  };
